module.exports = __webpack_public_path__ + "img/Psychothon.fa504cfc.png";